import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide9: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Queen <span>-</span>
            <br /> I Want To Break Free
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=f4Mc-NYPHaQ"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Rita Comparato</S.Name>
          <S.Profile>Estilista</S.Profile>
          <S.Text>
            “Eu amo ‘I want to break free’, do Queen. Adorava o Fred Mercury
            vestido de dona de casa, passando aspirador de pó. Mas o último que
            me impressionou foi ‘Chandelier’, da Sia, com a menina correndo pela
            casa.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
